import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {Stack, Box, OutlinedInput, Button, Typography} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import {useDarkMode} from "../../darkMode/hook/useDarkMode";

const   Identity = ({handleNextStep}) => {
  const {
    control,
    formState: {errors},
    reset,
  } = useFormContext();
    console.log(errors);

  const {mode} = useDarkMode();
  return (
    <Stack className={"form_group"} style={{backgroundColor: mode.settings.cardBackgroundColor}}>
        <Stack direction={"row-reverse"} spacing={5} gap={2} flexWrap={"wrap"} justifyContent={"center"}

        >
            <Stack direction={"column"} sx={{marginRight : '0px !important', width : '40%'}}>
                <Typography
                    className={"form_label"}
                    variant={"subtitle1"}
                    component={'label'}
                    id={'label-lastname'}
                    htmlFor={'lastname'}
                    color={mode.settings.textColor3}
                >
                    Nom
                </Typography>
                <Controller
                    control={control}
                    name="lastName"
                    rules={{
                        required: true,
                    }}
                    render={({field: {onChange, value}}) => (
                        <OutlinedInput
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            error={!!errors.lastName}
                            placeholder="Dupont"
                            style={{
                                maxWidth: 500,
                            }}
                            id="lastname"
                            aria-describedby="label-lastname"
                            sx={{background :mode.settings.inputBackgroundColor, color:mode.settings.textColor3}}
                        />
                    )}
                />
            </Stack>
            <Stack sx={{marginRight : '0px !important', width : '40%'}}>
                <Typography
                    className={"form_label"}
                    variant={"subtitle1"}
                    component={'label'}
                    id={'label-firstname'}
                    htmlFor={'firstname'}
                    color={mode.settings.textColor3}
                >
                    Prénom
                </Typography>
                <Controller
                    control={control}
                    name="firstName"
                    render={({field: {onChange, value}}) => (
                        <OutlinedInput
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            error={!!errors.firstName}
                            placeholder="Jean"
                            style={{
                                maxWidth: 500,
                            }}
                            id="firstname"
                            aria-describedby="label-firstname"
                            sx={{background :mode.settings.inputBackgroundColor, color:mode.settings.textColor3}}
                        />
                    )}
                />
            </Stack>
        </Stack>

      <br/>
        <Stack
            direction={"row"}
            justifyContent={{xs : 'center' , md : 'center' , lg : 'flex-end'}}
            marginRight={{xs : 0 , md : 0 , lg : '103px'}}
        >
            <Button
                className="btn-gradient"
                startIcon={<CheckIcon role="img" aria-label={"Valider"}/>}
                style={{
                    width : 130
                }}
                onClick={() => handleNextStep && handleNextStep()}
            >
                <Typography variant={'subtitle3'} color={'white'}>
                    Valider
                </Typography>
            </Button>
        </Stack>
    </Stack>
  );
};



export default Identity;
